class Question{
    constructor(questionName,question, answer){
        this.questionName = questionName;
        this.question = question;
        this.answer = answer;
    }
}



export default  Question;